import { BehaviorSubject, Observable, take, takeUntil } from "rxjs";

export const subjectFromObs = <T>(params: {
  observable: Observable<T>
  until?: Observable<any>
  initialValue: T,
}) => {

  const { observable, until, initialValue } = params;
  const subject = new BehaviorSubject<T>(initialValue);


  if (until) {
    observable.pipe(takeUntil(until))
      .subscribe((value) => subject.next(value))
  }
  else {
    observable.subscribe((value) => subject.next(value))
  }


  until?.pipe(
    take(1)
  )
    .subscribe(() => {
      subject.complete()
    })

  return subject;
}
